import { render, staticRenderFns } from "./PermalinkPlugin.vue?vue&type=template&id=07b6dcb1&scoped=true"
import script from "./PermalinkPlugin.vue?vue&type=script&lang=ts"
export * from "./PermalinkPlugin.vue?vue&type=script&lang=ts"
import style0 from "./PermalinkPlugin.vue?vue&type=style&index=0&id=07b6dcb1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6dcb1",
  null
  
)

export default component.exports